import styled from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

export const SvgIconWrapper = styled.span.withConfig({
  shouldForwardProp: (prop) =>
    isPropValid(prop) && prop !== 'height' && prop !== 'width',
})<{ height: number; width: number }>`
  display: inline-block;
  font-size: 0; // remove inline-block 4px
  vertical-align: top; // corrects for baseline alignment

  fill: currentColor; // use the value of the CSS 'color' property as fill for the svg

  svg {
    height: ${({ height }) => `${height}px`};
    width: ${({ width }) => `${width}px`};
  }
`;
